import { render } from "./Floors.vue?vue&type=template&id=6fa72a20"
import script from "./Floors.vue?vue&type=script&lang=js"
export * from "./Floors.vue?vue&type=script&lang=js"

import "./Floors.vue?vue&type=style&index=0&id=6fa72a20&lang=scss"
script.render = render

export default script